import { useMutation } from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';

export default function useJoinTournament(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  return useMutation({
    mutationFn: async (payload: { tournamentId: number; playerId: number }) => {
      const response = await TournamentRestClient.post(
        `/players/join-tournament/${payload.tournamentId}`,
        { playerId: payload.playerId }
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });
}
